'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isValid = function isValid(value) {
  return value !== undefined && value !== null && value !== '';
};
exports['default'] = isValid;